<template>
  <div class="preview-item" :style="cssProps" :class="{ reverse: reverse }">
    <Stiching id="one" :name="name" />
    <Stiching id="two" :name="name" />
    <Stiching id="three" :name="name" />
    <Stiching id="four" :name="name" />
  </div>
</template>

<script>
import Stiching from "./Stiching.vue";
export default {
  components: { Stiching },
  props: {
    name: {
      type: Number,
      default: 0,
    },
    proportion: {
      type: Number,
      deafault: 0,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      img: null,
    };
  },
  computed: {
    cssProps() {
      return {
        "--height": `${this.proportion}vh`,
      };
    },
  },
  mounted() {
    this.img = require(`../assets/preview-${this.name}.png`);
  },
};
</script>

<style lang="scss" scoped>
.preview-item {
  position: relative;
  height: var(--height);
  &:hover {
    .stiching {
      animation-play-state: paused !important;
      -webkit-animation-play-state: paused;
    }
  }
  .stiching {
    position: absolute;
    height: var(--height);
    left: 100%;
    top: 0;
    transform: translate(500%, 0);
    animation: secondmove 720s infinite linear;
  }

  #one {
    left: 0;
    animation: firstmove 720s infinite linear;
    animation-fill-mode: forwards;
    transform: translate(0, 0);
  }

  #two {
  }

  #three {
    animation-delay: 240s;
  }

  #four {
    animation-delay: 480s;
  }

  @keyframes firstmove {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-300%, 0);
    }
  }

  @keyframes secondmove {
    0% {
      transform: translate(100%, 0);
    }
    100% {
      transform: translate(-200%, 0);
    }
  }
}

.reverse {
  .stiching {
    animation: secondmoveReverse 720s infinite linear;
  }

  #one {
    animation: firstmoveReverse 720s infinite linear;
  }
  @keyframes firstmoveReverse {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(300%, 0);
    }
  }

  @keyframes secondmoveReverse {
    0% {
      transform: translate(-100%, 0);
    }
    100% {
      transform: translate(200%, 0);
    }
  }
}
</style>
